// eslint-disable-next-line no-unused-vars
import React, { CSSProperties, useEffect, useState } from "react";
import XDiv from "./XDiv";
import ColorXAddOns from "IZOX/STATIC/_extra/ColorXAddOns";
import AtthExpress from "IZOX/ARCS/API/AtthExpress";
import _ from "lodash";
import { DOMAIN } from "__SYSDefault/Domain";
import ZCache from "IZOX/STATIC/ZCache";

/**
 * @typedef {import("./XDiv").xdivparams} xdivparams
 * 
 * @typedef {Object} ximageparams
 * @property {Number | String} width
 * @property {Number | String} height
 * @property {Object | String} source
 * @property {Boolean} noResize
 * @property {"fill" | "contain" | "cover" | "none" | "scale-down" | "initial" | "inherit"} objectFit
 * @property {String} SVGColor
 * @property {CSSProperties} imgStyle
 * @property {Boolean} SVGDebug
 * @property {String} alt
 * 
 * @param {ximageparams & xdivparams} param0
 * 
 */
function XImage({
  width = "auto",
  height = "auto",
  noResize = false,
  source = "",
  objectFit = "cover",
  SVGColor = undefined,
  imgStyle = {},
  SVGDebug = false,
  alt = "",
  ...others
}){

  const [src, setSrc] = useState("");

  useEffect(() => {

    let timeout;

    async function fetch(){
      let _src = source;
      if(_.isArray(source) && source.length > 0){
        _src = source[0];
      }

      if(!_.isString(_src)){
        if(_src.refID){
          if(_src.refID.startsWith("izox::")){
            let res = await AtthExpress.GetBlobUrl(_src.refID);
            let {url} = res;
            if(!url?.startsWith("http")){
              url = `${DOMAIN}${url?.slice(1)}`;
            }
            timeout = setTimeout(() => setSrc(url), 0);
          }else{
            timeout = setTimeout(() => setSrc(_src.refID), 0);
          }
        }else{
          timeout = setTimeout(() => setSrc(_src), 0);
        }
      }else{
        if(_src?.startsWith("izox::")){
          let res = await AtthExpress.GetBlobUrl(_src);
          timeout = setTimeout(() => setSrc(res.url), 0);
        }else{
          timeout = setTimeout(() => setSrc(_src), 0);
        }
      }
    }
    fetch();
    return () => {
      if(timeout){
        clearTimeout(timeout);
      }
    };
  }, [source]);

  let _flexShrink = undefined;
  if(noResize) _flexShrink = 0;

  imgStyle = {
    display: "block",
    width: "100%", 
    maxWidth: "100%",
    height: "100%", 
    maxHeight: "100%",
    objectFit: objectFit,
    ...imgStyle
  };

  if(SVGColor){
    let svgcolor = ZCache.Get(SVGColor, () => ColorXAddOns.CSStoFilterRetry(SVGColor, {perfect: 0.01, maxLoss: 0.3}), 1, "day");
    if(SVGDebug) console.log("SVGColor Loss: " + svgcolor.loss + " Trials: " + svgcolor.trials);
    imgStyle.filter = svgcolor.filter;
  }

  return (
    <XDiv 
      width={width}
      height={height}
      flexShrink={_flexShrink}
      overflow="hidden"
      {...others}>
      {!_.isEmpty(src) && <img src={src} alt={alt ?? ""} style={imgStyle}/>}
    </XDiv>
  );
}

export default XImage;